<template>
  <v-container>
    <v-row v-if="showAnimation" justify="center" align="center">
      <div style="height: 300px;">
        <loading-animation @loopComplete="loadAnimationComplete"></loading-animation>
      </div>
    </v-row>
    <v-row v-show="!showAnimation" justify="center" align="center">
      <v-col cols="12" align-self="start" align="start">
        <span
          v-if="dia"
          class="ml-n2 mt-3"
          style="
          color: white;
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
          "
        >
          {{ this.diaSemana }}, {{ this.dia }} de {{ this.mes }} de
          {{ this.ano }}
        </span>
      </v-col>
      <v-col cols="12" style="overflow-x: auto" class="mt-n6">
        <div id="chart-meteorogical-tomorrow" style="min-width: 2000px"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/*eslint-disable*/
import Accessibility from 'highcharts/modules/accessibility';
import Highcharts from "highcharts";
import moment from "moment";
Accessibility(Highcharts);
import LoadingAnimation from "../LoadingAnimation";
export default {
  components: {LoadingAnimation},
  props: ["hourly", "location"],
  name: "TomorrowMeteorologicalChart",
  data: () => ({
    dia: undefined,
    diaSemana: undefined,
    mes: undefined,
    ano: undefined,
    tomorrow: moment()
      .tz("America/Sao_Paulo")
      .locale("pt-br")
      .add(1, "days")
      .format("YYYY-MM-DDTHH:mm:ss"),
    arrayPrecAmanha: [],
    arrayTempAmanha: [],
    loading: false,
    showAnimation: false,
    chartRendered: undefined,
  }),
  watch:{
    hourly(){
      if(this.hourly){
        this.initialize()
      }
    }
  },
  mounted() {
    this.dia = moment(this.tomorrow, "YYYY-MM-DDTHH:mm:ss")
      .tz("America/Sao_Paulo")
      .format("DD");
    this.diaSemana = moment(this.tomorrow, "YYYY-MM-DDTHH:mm:ss")
      .tz("America/Sao_Paulo")
      .locale("pt-br")
      .format("dddd");
    this.mes = moment(this.tomorrow, "YYYY-MM-DDTHH:mm:ss")
      .tz("America/Sao_Paulo")
      .locale("pt-br")
      .format("MMMM");
    this.ano = moment()
      .tz("America/Sao_Paulo")
      .format("YYYY");
    this.initialize()
  },
  methods: {
    loadAnimationComplete(){
      this.showAnimation = this.loading;
    },
    async initialize(){
      this.loading = true;
      this.showAnimation = true;
      this.arrayPrecAmanha = [];
      this.arrayTempAmanha = [];
      let resHourly = this.hourly
      let iconsHourly = {}
      let position, lastPosition
      let lastOfDay = moment().add(1, 'day').tz("America/Sao_Paulo").format("YYYY-MM-DDT23")
      let initialOfDay = moment().add(1, 'day').tz("America/Sao_Paulo").format("YYYY-MM-DDT00")
      for(let item in resHourly){
        if(moment(resHourly[item].date).tz("America/Sao_Paulo").format("YYYY-MM-DDTHH") === initialOfDay){
          position = item
        }
        if(moment(resHourly[item].date).tz("America/Sao_Paulo").format("YYYY-MM-DDTHH") === lastOfDay){
          lastPosition = item
        }
      }
      for (let index = position; index <= Number(lastPosition); index++) {
        let itemHourly = {
          icon: this.mapIcon(resHourly[index].summaryId,resHourly[index].date),
          text: this.mapText(resHourly[index].summaryId),
          id: resHourly[index].summaryId,
          date: resHourly[index].date
        }
        let dateF = new Date(resHourly[index].date).getTime()
        iconsHourly[dateF] = itemHourly
        this.arrayPrecAmanha.push([
          new Date(resHourly[index].date).getTime(),
          resHourly[index].precIntensity,
        ]);
        this.arrayTempAmanha.push([
          new Date(resHourly[index].date).getTime(),
          resHourly[index].temp,
        ]);
      }
      this.chartRendered = Highcharts.chart("chart-meteorogical-tomorrow", {
        chart: {
          backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
        },
        title: { text: null },
        subtitle: { text: null },
        credits: {
          enabled: false,
          href: "http://www.simepar.br/",
          text: "by: SIMEPAR",
          style: { color: "#FFFFFF" },
        },
        legend: {
          enabled: false,
          itemStyle: { color: "#FFFFFF" },
          itemHoverStyle: { color: "#979797" },
        },
        xAxis: {
          opposite: true,
          lineColor: 'transparent',
          gridLineColor: 'transparent',
          minorGridLineColor: 'transparent',
          tickColor: 'transparent',
          visible: true,
          labels: {
            useHTML: true,
            formatter: function() {
              if(iconsHourly[this.value].icon !== ' ' && iconsHourly[this.value].text !== ' '){
                return '<span style="color: #FFFFFF; font-size: 16px; font-weight: bold;">'+ moment(iconsHourly[this.value].date, 'YYYY-MM-DDTHH:mm:ssZ').tz("America/Sao_Paulo").format("HH:mm") +'</span>'
                  +'<br>'+
                  '<i class="'+ iconsHourly[this.value].icon +'" style="color: #FFFFFF; font-size: 40px"></i>';
              } else {
                return '<span style="color: #FFFFFF; font-size: 16px; font-weight: bold;">'+ moment(iconsHourly[this.value].date, 'YYYY-MM-DDTHH:mm:ssZ').tz("America/Sao_Paulo").format("HH:mm") +'</span>'
                  +'<br>'+
                  '<i class="icon-infohidro-wi-day-cloudy" style="color: transparent; font-size: 40px"></i>'
              }
            }
          },
          type: "datetime",
          /*            labels: {
                        enabled: true,
                        format: "{value:%H:%M}",
                        style: { color: "#FFFFFF" },
                      },*/
          title: {
            enabled: false,
            style: { color: "#FFFFFF" },
          },
        },
        yAxis: [
          {
            visible: false,
            reversed: false,
            opposite: false,
            min: 0,
            height: "70%",
          },
          {
            visible: false,
            reversed: true,
            opposite: true,
            min: 0,
            top: "60%",
            height: "30%",
            offset: 0,
          },
        ],
        plotOptions: {
          series: {
            marker: { enabled: true },
          },
        },
        colors: ["#0071B0", "#FF9F00"],
        tooltip: {
          useHTML: true,
          backgroundColor: '#212a35',
          borderWidth: 0,
          formatter: function () {
            return this.points.reduce(function (s, point) {
              return s +'<div style="background-color: #212a35">'+ '<br/>' + '<b style="color:' + point.series.color + '">' +point.series.name + ': ' + '</b>'+
                '<b style="color: #FFFFFF">' + (point.y).toFixed(point.series.tooltipOptions.valueDecimals) + point.series.tooltipOptions.valueSuffix +'</b>';
            }, '<b style="text-transform: capitalize; color: #FFFFFF">' + moment.utc(this.x).tz("America/Sao_Paulo").format('DD/MM/YYYY HH:mm') + '</b>' + '<br/>' + '<b style="color: #FFFFFF">' + iconsHourly[this.x].text + '</b>' + '<br/>' + '</div>');
          },
          shared: true,
          crosshairs: true,
        },
        series: [
          {
            name: "Precipitação",
            type: "column",
            yAxis: 1,
            data: this.arrayPrecAmanha,
            tooltip: {
              valueDecimals: 1,
              valueSuffix: "mm",
            },
            dataLabels: {
              enabled: true,
              //format: '{y}mm',
              formatter: function () {
                return this.y.toFixed(1) + "mm";
              },
              verticalAlign: "top",
              style: { color: "#FFFFFF" },
            },
          },
          {
            name: "Temperatura",
            type: "line",
            yAxis: 0,
            data: this.arrayTempAmanha,
            tooltip: {
              valueDecimals: 0,
              valueSuffix: "°C",
            },
            dataLabels: {
              enabled: true,
              //format: '{y}˚C',
              formatter: function () {
                return this.y.toFixed(0) + "˚C";
              },
              verticalAlign: "bottom",
              style: { color: "#FFFFFF" },
            },
          },
        ],
        caption: {
          text: `Gráfico de dados metereológicos de amanhã ${this.dia} de ${this.mes} de ${this.ano}`,
          style: { color: '#FFFFFF'}
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                plotOptions: {
                  series: {
                    marker: {
                      radius: 2.5,
                    },
                  },
                },
              },
            },
          ],
        },
        exporting: {
          enabled: false,
          filename: this.location.text + ' - ' + 'amanhã',
          sourceWidth: 2000,
          chartOptions: {
            title: {
              text: 'Dados meteorológicos para amanhã',
              style: {
                color: '#FFFFFF'
              }
            },
            subtitle: {
              text: this.location.text,
              style: {
                color: '#FFFFFF'
              }
            },
          }
        },
      });
      this.$emit('chartRenderComplete', this.chartRendered);
      this.loading = false;
    },
    mapIcon(id, date) {
      let icon, isDay = true
      let holder = moment(date, 'YYYY-MM-DDTHH:mm:ssZ').tz("America/Sao_Paulo").format("HH")
      if(holder <= '06' || holder >= '18') { isDay = false }
      if (id == 4) {
        icon = "icon-infohidro-wi-cloud";
      } else if (id == 6) {
        icon = "icon-infohidro-wi-rain";
      } else if(id == 7){
        icon = "icon-infohidro-wi-thunderstorm";
      } else if (id == 8) {
        icon = "icon-infohidro-wi-snowflake-cold";
      } else if (id == 9) {
        icon = "icon-infohidro-wi-snow";
      } else if (id == 11) {
        icon = "icon-infohidro-wi-fog";
      } else if (id == 999) {
        icon = " ";
      }
      if (isDay == true) {
        if (id == 1) {
          icon = "icon-infohidro-wi-day-sunny";
        } else if (id == 2) {
          icon = "icon-infohidro-wi-day-sunny-overcast";
        } else if (id == 3) {
          icon = "icon-infohidro-wi-day-cloudy";
        } else if (id == 5) {
          icon = "icon-infohidro-wi-day-rain";
        } else if (id == 10) {
          icon = "icon-infohidro-wi-day-thunderstorm";
        } else if (id == 999) {
          icon = " ";
        }
      } else if (isDay == false) {
        if (id == 1) {
          icon = "icon-infohidro-wi-night-clear";
        } else if (id == 2) {
          icon = "icon-infohidro-wi-night-alt-partly-cloudy";
        } else if (id == 3) {
          icon = "icon-infohidro-wi-night-alt-cloudy";
        } else if (id == 5) {
          icon = "icon-infohidro-wi-night-alt-rain";
        } else if (id == 10) {
          icon = "icon-infohidro-wi-night-thunderstorm";
        } else if (id == 999) {
          icon = " ";
        }
      }
      return icon;
    },
    mapText(id) {
      let text;
      if (id == 4) {
        text = "Nublado";
      } else if (id == 6) {
        text = "Chuva";
      } else if (id == 7) {
        text = "Tempestade";
      } else if (id == 8) {
        text = "Geada";
      } else if (id == 9) {
        text = "Neve";
      } else if (id == 11) {
        text = "Neblina";
      } else if (id == 1) {
        text = "Céu Claro";
      } else if (id == 2) {
        text = "Poucas Nuvens";
      } else if (id == 3) {
        text = "Muitas Nuvens";
      } else if (id == 5) {
        text = "Parcialmente nublado com pancadas de chuva";
      } else if (id == 10) {
        text = "Parcialmente Nublado com chuvas e trovoadas";
      } else {
        text = " ";
      }
      return text;
    },
  },
}
</script>

<style scoped>

</style>
